import useHomeType from 'hooks/useHomeType'
import OrganisationScreen from './OrganisationScreen'

export const OrganisationScreenFeatureFlagWrapper = () => {
  const { hasRota } = useHomeType()

  return <OrganisationScreen hasRota={hasRota} />
}
